import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './Shared/Guards/auth.guard';
const isMaster = localStorage.getItem('profile_name') === '7d4e9f24-17e8-11ec-9621-0242ac130002';
const isMasterAssociate = localStorage.getItem('profile_name') === '7415bb4a-c1e9-401d-870a-7af65a8e3acd';

const getHomeRoute = () => {
    const keepConnected = localStorage.getItem('keep-connected');
    if (keepConnected != null) {
        if (keepConnected === 'false') {
            if (!sessionStorage.getItem('id-token')) {
                return '/login/signin';
            }
            else {
                if (isMaster || isMasterAssociate) {
                    return '/users/partners';
                } else {
                    return '/home';
                }
            }
        }
        else {
            if (localStorage.getItem('id-token') != null) {
                if (isMaster || isMasterAssociate) {
                    return '/users/partners';
                } else {
                    return '/home';
                }
            }
            else {
                return '/login/signin';
            }
        }
    }
    else {
        return '/login/signin';
    }
};

const routes: Routes = [
    {
        path: 'shared',
        loadChildren: () => import('./public/public.module').then(m => m.PublicModule),
        data: { preLoad: true }
    },
    {
        path: 'home',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'cameras',
        loadChildren: () => import('./cameras/cameras.module').then(m => m.CamerasModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'users',
        loadChildren: () => import('./Users/users.module').then(m => m.UsersModule),
    },
    {
        path: 'analytics',
        loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule),
    },
    // {
    //   path: 'home',
    //   component: CameraViewComponent,
    //   canActivate: [AuthGuard]
    // },
    {
        path: '',
        redirectTo: getHomeRoute(),
        pathMatch: 'full'
    },
    /*{
    path: 'cadastros',
    loadChildren: 'app/Plans/plan.module#PlanModule'
  },
  {
    path: 'settings',
    loadChildren: 'app/Profiles/profile.module#ProfileModule'
  },
  {
    path: 'deals',
    loadChildren: 'app/Requests/requests.module#RequestModule'
  }*/
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes, { useHash: true })
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
